export default __webpack_public_path__ + "static/12-df07c87528a6675f9778554770ec0743.jpg";